

                if (!window.beaePageJS) {
                    window.beaePageJS = [];
                }
                let jsHandle_cpa07q2ap2 = () => {
                    
                        if (document.querySelector('.beae-5l282k2k:not([data-beae-bind])')) {
                            (function() {if(!this.isLive)return;let i=window.innerWidth,_=()=>{this.$el&&this.$el.querySelector(".beae-section-background-video")&&typeof handleVideoBg<"u"?(handleVideoBg.bind(this)(),window.addEventListener("resize",()=>{window.innerWidth!=i&&(i=window.innerWidth,handleVideoBg.bind(this)())})):setTimeout(()=>_(),500)};_()}).call({
                                $el: document.querySelector('.beae-5l282k2k:not([data-beae-bind])'),
                                
                                id: 'beae-5l282k2k',
                                isLive: true
                            });
                            document.querySelector('.beae-5l282k2k:not([data-beae-bind])').setAttribute('data-beae-bind', true);
                        }
                
                        if (document.querySelector('.beae-uqstbw4o:not([data-beae-bind])')) {
                            (function() {let e=this.$el.querySelector(".beae-shopify__newsletter-form-wrapper");if(e&&typeof getCurrentScreen<"u"&&this.isLive){let n=function(){let o=getCurrentScreen(t),r=a[o.name],l=r?r.design:null;l&&e.setAttribute("data-layout",s(l,o,"design"))},s=function(o,r,l){if(o)return o;let c=t.findIndex(m=>m.name==r.name),d=(m,_)=>{let u=t[m].name,g="";return a[u][_]?g=a[u][_]:m>0&&(g=d(m-1,_)),g};return d(c,l)},t=JSON.parse(e.getAttribute("data-screens")),a=JSON.parse(e.getAttribute("data-responsive"));window.addEventListener("resize",n),n()}}).call({
                                $el: document.querySelector('.beae-uqstbw4o:not([data-beae-bind])'),
                                
                                id: 'beae-uqstbw4o',
                                isLive: true
                            });
                            document.querySelector('.beae-uqstbw4o:not([data-beae-bind])').setAttribute('data-beae-bind', true);
                        }
                
                        if (document.querySelector('.beae-j4a7lu2t:not([data-beae-bind])')) {
                            (function() {let $el = this.$el;
                let limit = this.settings.itemsCount ? this.settings.itemsCount : 8;
                function getToken() {
                    if (window.BEAE && window.BEAE.configs && window.BEAE.configs.instagram) {
                        return window.BEAE.configs.instagram;
                    } else {
                        let token = window.localStorage.getItem('beae-instagram');
                        return token ? token : null;
                    }
                }
                const appendHTML = (medias) => {
                    let html = "";
                    let new_window = this.settings.new_window
                    let link = this.settings.link,
                        lightbox = link === "media" ? this.settings.lightbox : 'no';
    
                 
                        html += medias
                        .map((m) => {
                            let text_caption = ""
                            if(this.settings.overlay_title ==="username") {
                                text_caption = m.username
                            } else if(this.settings.overlay_title === "caption") {
                                text_caption = m.caption
                            } else {
                                text_caption = this.settings?.icon_item
                            }

                            return `<div class="beae-instagram--item ${
                                this.settings.layout === "slider" ? " beae-swiper-slide" : ""
                            }">
                                ${ link ? `<a target="${new_window ? '_blank' : ''}" href="${link === "media" ? m.media : m.url}" ${ lightbox == 'yes' ? `data-beae-popup="gallery"` : ""}>`
                                        : ""
                                }
                                    <figure class="beae-image-default">
                                        <img src="${m.thumb}" alt="${m.username}">

                                        ${

                                            this.settings.overlay_use
                                                ? `<div class="beae-base-instagram-overlay beae-overlay">
                                                ${
                                                    this.settings.overlay_title
                                                    ? `<span class="beae-overlay-text">${text_caption!==undefined?text_caption:''} </span>`
                                                    : ""
                                                }


                                            </div>`
                                                : ""
                                        }
                                    </figure>
                                ${link ? "</a>" : ""}
                            </div>`;
                        })
                        .join("");
                        $el.querySelector(".beae-instagram-wrapper").innerHTML = html;
                   
                    
                };

                const getMedias = (token) => {
                    let kStore = "beae-instagram-" + token;
                    return new Promise((resolve, reject) => {
                        let dataStore = window.localStorage.getItem(kStore);
                        if (dataStore) {
                            let jData = JSON.parse(dataStore);
                            if (jData.exp >= new Date() && jData.data.length >= limit) {
                                resolve(jData.data.slice(0, limit));
                                return false;
                            } else {
                                window.localStorage.removeItem(kStore);
                                getMedias(token).then((response) => resolve(response));
                            }
                        } else {
                            window
                                .fetch(
                                    "https://graph.instagram.com/me/media?" +
                                        new URLSearchParams({
                                            fields: "id,caption,media_url,thumbnail_url,media_type,permalink,username",
                                            access_token: token,
                                            limit
                                        }).toString()
                                )
                                .then((res) => res.json())
                                .then((response) => {
                                    if (response && response.data) {
                                        const getKey = (type, key) => {
                                            let ks = {
                                                image: {
                                                    thumb: "media_url",
                                                    media: "media_url",
                                                    url: "permalink"
                                                },
                                                video: {
                                                    thumb: "thumbnail_url",
                                                    media: "media_url",
                                                    url: "permalink"
                                                },
                                                carousel_album: {
                                                    thumb: "media_url",
                                                    media: "media_url",
                                                    url: "permalink"
                                                }
                                            };
                                            return ks?.[type]?.[key];
                                        };
                                        let datas = response.data.map((item) => {
                                            let type = item.media_type.toLowerCase();
                                            return {
                                                type,
                                                thumb: item[getKey(type, "thumb")],
                                                media: item[getKey(type, "media")],
                                                url: item[getKey(type, "url")],
                                                username: item.username,
                                                caption: item.caption
                                            };
                                        });
                                        window.localStorage.setItem(
                                            kStore,
                                            JSON.stringify({
                                                exp: new Date().setDate(new Date().getDate() + 7),
                                                data: datas
                                            })
                                        );
                                        resolve(datas);
                                    }
                                })
                                .catch((e) => {
                                    reject(e);
                                });
                        }
                    });
                };
                const initSlider = () => {
                    let $container = $el.querySelector(".beae-swiper-container");
                    let options = JSON.parse($container.dataset.optionSwiper);
                    options.pagination.el = $el.querySelector('.beae-swiper-pagination');
                    options.navigation.nextEl = $el.querySelector('.beae-swiper-button-next');
                    options.navigation.prevEl = $el.querySelector('.beae-swiper-button-prev');
                    const params = {
                        allowTouchMove: this.isLive
                    };
                    // options.slidesPerView = 4;
                    new window.BeaeSwiper($container, Object.assign(options, params))
                };
                let token = getToken();
                if (!token) {
                    return false;
                }
                // token demo 'IGQVJYc1V2cS1LRW9pRE5mTXJ0Tjh5V19yaWZAHTUNqd05SQVh2aHE3Ynl0Wjg2aExhWTZA3YmlvVG5JOWRvQ25FajJwQ0dtM1QtSzR3aFhuWVF3aGJ0X3YyZAS1kTEN3cUV5RHI3VTB3'
                getMedias(token)
                    .then((res) => { 
                
                        appendHTML(res);
                        if (this.settings.layout === "slider") {
                            initSlider();
                        }
                        window
                            .jQuery($el)
                            .find("[data-beae-popup]")
                            .beaePopup({
                                type: "image",
                                gallery: {
                                    enabled: true
                                }
                            });
                    })
                    .catch((e) => {
                        console.info(e.message);
                    });}).call({
                                $el: document.querySelector('.beae-j4a7lu2t:not([data-beae-bind])'),
                                settings: {"itemsCount":6,"overlay_title":"username","layout":"grid","overlay_use":true},
                                id: 'beae-j4a7lu2t',
                                isLive: true
                            });
                            document.querySelector('.beae-j4a7lu2t:not([data-beae-bind])').setAttribute('data-beae-bind', true);
                        }
                
                        if (document.querySelector('.beae-wknsq7ub:not([data-beae-bind])')) {
                            (function() {let e=this.$el,t=e.querySelector(".beae-shopify__feature-blog-wrapper[data-screen]"),o=e.querySelector(".beae-shopify__feature-blog--title[data-style]"),a=[],l=[],s="",n=["beae-style--left","beae-style--center","beae-style--right","beae-style--"],p=e.querySelector(".beae-shopify__feature-blog--title");t&&(s=t.getAttribute("data-screen"),s&&(a=JSON.parse(s))),window.addEventListener("resize",r.bind(this));function r(){if(!s)return;o&&(dt_style=o.getAttribute("data-style"),dt_style&&(l=JSON.parse(dt_style)));let d={};a.forEach((b,g)=>{let c=!1,u=g==a.length-1;if(g==0)c=window.matchMedia(`only screen and(min-width:${b.min+1}px)`);else{let _=`only screen and(max-width:${b.width}px)${u?"":`and(min-width:${b.min+1}px)`}`;c=window.matchMedia(_)}c&&c.matches&&(d=b)}),a[0].name!=d.name&&p&&(p.classList.remove(...n),p.classList.add(`beae-style--${l[d.name]}`))}}).call({
                                $el: document.querySelector('.beae-wknsq7ub:not([data-beae-bind])'),
                                
                                id: 'beae-wknsq7ub',
                                isLive: true
                            });
                            document.querySelector('.beae-wknsq7ub:not([data-beae-bind])').setAttribute('data-beae-bind', true);
                        }
                window.addEventListener("load", () => {let brd = document.createElement("div"),id = Math.random().toString(36).substr(2, 5);brd.setAttribute(`data-${id}`, "");brd.setAttribute("style","position:fixed;bottom: 10px;left:14px;z-index:99999999999999;display:flex;align-items:center;gap:10px");brd.innerHTML = `<a href="https://apps.shopify.com/beae/?utm_source=customersite&utm_medium=page&utm_campaign=traffic" target="_blank" style="box-shadow:rgb(0 0 0 / 25%) 0px 54px 55px, rgb(0 0 0 / 12%) 0px -12px 30px, rgb(0 0 0 / 12%) 0px 4px 6px, rgb(0 0 0 / 17%) 0px 12px 13px, rgb(0 0 0 / 9%) 0px -3px 5px;background:#fafafa;border-radius: 6px;padding: 3px 8px;text-decoration: none;font-family: system-ui, arial;font-size: 12px;color: #292929;font-weight: 500;display: flex;align-items: center;letter-spacing: 0;white-space: nowrap;">Made in <img src="https://app.beae.com/dist/images/beae.svg" height="14" style="border-radius: 0px;margin-left:3px;height:14px !important" /></a> `;document.body.appendChild(brd);});
                }
                if (window.beaejQuery) {
                    jsHandle_cpa07q2ap2()
                } else {
                    window.beaePageJS.push(jsHandle_cpa07q2ap2)
                }
            